import api from "../api/axiosInstance";

const emailContactService = {
  getAll: () => api.get("/email-contacts"),
  create: (label, email) => api.post("/email-contacts", { label, email }),
  remove: (id) => api.delete(`/email-contacts/${id}`),
};

export default emailContactService;
